export default {
  fields: [
    {
      name: 'field-generic-input',
      title: 'Order Name',
      prop: 'name',
      width: '152px',
      inputProps: {
        type: 'text',
      },
    },
    {
      name: 'field-generic-input',
      width: '152px',
      title: 'Message',
      prop: '_errorMsg',
      id: '_errorMsg',
    },
  ]
}